import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --color-primary: #FF9052;
    --color-secondary: #1A1A1A;
    --color-accent: #FFBB33;
    --color-white: #FFFFFF;
    --color-gray: #333333;
    --color-light-gray: #666666;
    --color-dark: #121212;
    --color-dark-gray: #222222;
    --font-primary: 'Montserrat', sans-serif;
    --font-secondary: 'Poppins', sans-serif;
  }
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body {
    font-family: var(--font-primary);
    background-color: var(--color-dark);
    color: var(--color-white);
    overflow-x: hidden;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-secondary);
    font-weight: 700;
  }
  
  a {
    color: var(--color-primary);
    text-decoration: none;
    transition: all 0.3s ease;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  button {
    font-family: var(--font-primary);
    cursor: pointer;
    border: none;
    outline: none;
  }
  
  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: var(--color-dark);
  }
  
  ::-webkit-scrollbar-thumb {
    background: var(--color-primary);
    border-radius: 4px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: var(--color-accent);
  }
  
  /* Responsividade para dispositivos móveis */
  @media (max-width: 768px) {
    html {
      font-size: 14px;
    }
    
    h1 {
      font-size: 2.5rem;
    }
    
    h2 {
      font-size: 2rem;
    }
    
    h3 {
      font-size: 1.5rem;
    }
    
    /* Ajustes para elementos de jogo em telas pequenas */
    #game-elements-container {
      transform: scale(0.8);
    }
    
    /* Ajustes para controles em telas pequenas */
    #keyboard-controls-container,
    #audio-manager-container {
      transform: scale(0.8);
    }
  }
  
  @media (max-width: 480px) {
    html {
      font-size: 12px;
    }
    
    h1 {
      font-size: 2rem;
    }
    
    h2 {
      font-size: 1.8rem;
    }
    
    h3 {
      font-size: 1.3rem;
    }
    
    /* Ajustes para elementos de jogo em telas muito pequenas */
    #game-elements-container {
      transform: scale(0.7);
    }
    
    /* Ajustes para controles em telas muito pequenas */
    #keyboard-controls-container,
    #audio-manager-container {
      transform: scale(0.7);
    }
  }
`;

export default GlobalStyles;
